import style from '../style/content.module.less';
import Table from './Table';
import { useSelector, useDispatch } from '@/hooks/hooks';
import { Pagination } from 'antd';
import { pageChange } from '@/store/slices/page';

const TableCard: React.FC<TableCardProps> = props => {
  const { tableCardWrapper, title: StyleTitle, actionBtns, pagination } = style;
  const state = useSelector(s => s.page);
  const dispatch = useDispatch();
  const pageChangeHandler = (pageNum: number, pageSize: number) => {
    dispatch(pageChange({
      fn: props.initFn as InitFn,
      params: {
        ...state.params,
        pageNum,
        pageSize
      }
    }));
  };

  return (
    <div className={tableCardWrapper}>
      <div className={StyleTitle}>
        <span>{props.title}</span>
        <div className={actionBtns}>
          {
            props.actionBtns && [...props.actionBtns]
          }
        </div>
      </div>
      <div className={style.table}>
        <Table
          dataSource={state.list}
          columns={props.columns}
          loading={state.loading}
          pagination={false}
          rowKey={r => r.id}
        />
        <div className={style.pagination}>
          <div>共<span>{state.total}</span>条数据</div>
          <Pagination
            showQuickJumper
            showSizeChanger
            pageSizeOptions={[10, 20, 50]}
            className={pagination}
            total={state.total}
            current={state.pageNum}
            pageSize={state.pageSize}
            onChange={pageChangeHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default TableCard;